import SuperFetchV2 from '../../superFetchV2';
import qs from 'query-string';
import { GetTagListRequest } from './type';
import { TagsFindResponseBodyDto, TagsRelatedFindResponseBodyDto } from '../../../types/api/tags';

class TagApiV2 {
  /**
   *  태그 리스트 조회
   */
  getTagList = (data: GetTagListRequest): Promise<TagsFindResponseBodyDto> =>
    SuperFetchV2.get(`/tags?${qs.stringify(data, { skipNull: true, skipEmptyString: true })}`);
  /**
   *  연관 태그 리스트 조회
   */
  fetchRelateTagList = (id: string): Promise<TagsRelatedFindResponseBodyDto> =>
    SuperFetchV2.get(`/tags/${id}/related-tags`);
}

export default new TagApiV2();
